/**
 * File: StateField.js
 * Origin: isotect
 * Description: StateField component for forms.
 *
 * Version: v2.0.0
 * Created: 2026-01-08
 * Last Updated: 2026-01-21
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import DropDownField from "./DropDownField";

const US_STATES = [
    { id: "AL", value: "Alabama" },
    { id: "AK", value: "Alaska" },
    { id: "AZ", value: "Arizona" },
    { id: "AR", value: "Arkansas" },
    { id: "CA", value: "California" },
    { id: "CO", value: "Colorado" },
    { id: "CT", value: "Connecticut" },
    { id: "DE", value: "Delaware" },
    { id: "FL", value: "Florida" },
    { id: "GA", value: "Georgia" },
    { id: "HI", value: "Hawaii" },
    { id: "ID", value: "Idaho" },
    { id: "IL", value: "Illinois" },
    { id: "IN", value: "Indiana" },
    { id: "IA", value: "Iowa" },
    { id: "KS", value: "Kansas" },
    { id: "KY", value: "Kentucky" },
    { id: "LA", value: "Louisiana" },
    { id: "ME", value: "Maine" },
    { id: "MD", value: "Maryland" },
    { id: "MA", value: "Massachusetts" },
    { id: "MI", value: "Michigan" },
    { id: "MN", value: "Minnesota" },
    { id: "MS", value: "Mississippi" },
    { id: "MO", value: "Missouri" },
    { id: "MT", value: "Montana" },
    { id: "NE", value: "Nebraska" },
    { id: "NV", value: "Nevada" },
    { id: "NH", value: "New Hampshire" },
    { id: "NJ", value: "New Jersey" },
    { id: "NM", value: "New Mexico" },
    { id: "NY", value: "New York" },
    { id: "NC", value: "North Carolina" },
    { id: "ND", value: "North Dakota" },
    { id: "OH", value: "Ohio" },
    { id: "OK", value: "Oklahoma" },
    { id: "OR", value: "Oregon" },
    { id: "PA", value: "Pennsylvania" },
    { id: "RI", value: "Rhode Island" },
    { id: "SC", value: "South Carolina" },
    { id: "SD", value: "South Dakota" },
    { id: "TN", value: "Tennessee" },
    { id: "TX", value: "Texas" },
    { id: "UT", value: "Utah" },
    { id: "VT", value: "Vermont" },
    { id: "VA", value: "Virginia" },
    { id: "WA", value: "Washington" },
    { id: "WV", value: "West Virginia" },
    { id: "WI", value: "Wisconsin" },
    { id: "WY", value: "Wyoming" },
];

const US_STATES_ABBREVIATED = US_STATES.map(({ id }) => ({
    id: id,
    value: id,
}));

/**
 *
 * @returns
 */
function StateField({ state, setState, label = "State", abbreviated = true }) {
    return (
        <DropDownField
            label={label}
            options={abbreviated ? US_STATES_ABBREVIATED : US_STATES}
            selection={state}
            setSelection={setState}
        />
    );
}

export default StateField;
